import * as React from 'react';

const OrangeFlagIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 292 370" {...props}>
        <g fillRule="nonzero" fill="none">
            <path
                fill="#FFF"
                d="M0 280.901v89.09h291.708l-68.535-24.845-112.324-81.536-49.19-.245-23.689-.031z"
            />
            <path
                d="M144.513 63.845c.1 1.487-.288 2.205-1.808 2.715-9.284 3.112-16.859 4.101-26.678 4.046-3.648-.02-7.302-.307-10.719-1.782-1.457-.629-3.105-1.539-3.105-3.245 0-1.705-.001-.003-.001-.005-.405-2.46-.31-10.019-.237-13.654a1.396 1.396 0 00-1.84-1.36c-6.451 2.179-27.67 9.383-35.57 12.559-1.588.638-1.8.208-1.89-1.29-.22-3.562-.585-11.46-.958-19.82.89.457 1.897.72 2.965.72 3.604 0 6.526-2.93 6.526-6.542 0-3.612-2.922-6.54-6.526-6.54a6.47 6.47 0 00-3.465 1.005c-.289-6.595-.538-12.302-.667-14.92-.047-.942-.039-1.726 1.109-2.18C71.26 9.743 92.277.769 96.769.794c3.57.019 4.321.814 4.45 4.386.176 4.933.446 9.862.574 14.796.036 1.416.475 1.843 1.914 1.85 10.202.057 27.184-1.823 36.78-5.177 1.43-.5 1.824-.427 1.877 1.234.081 2.534.354 8.845.682 16.02a6.622 6.622 0 00-.902-.068c-3.604 0-6.525 2.928-6.525 6.54 0 3.614 2.92 6.542 6.525 6.542.518 0 1.019-.067 1.502-.18.39 8.166.745 15.282.867 17.108z"
                fill="#FFA71A"
            />
            <path
                d="M101.726 17.9c-.14-4.24-.355-8.479-.508-12.72-.128-3.573-.88-4.367-4.45-4.387C92.277.77 71.262 9.743 61.65 13.551c-1.148.456-1.156 1.239-1.11 2.18.13 2.618.38 8.326.668 14.921a6.473 6.473 0 013.465-1.006c3.604 0 6.525 2.929 6.525 6.542 0 3.612-2.921 6.54-6.525 6.54a6.473 6.473 0 01-2.965-.719c.373 8.36.739 16.258.957 19.819.091 1.5.303 1.929 1.89 1.29 7.902-3.175 29.12-10.38 35.57-12.557.919-.31 1.86.388 1.84 1.36-.073 3.635-.167 11.192.238 13.653v.005c0 .331.078.624.189.899l-.665-48.578zM134.793 167.13s-30.829 21.344-34.747 30.18c-3.917 8.836-9.752 53.197-9.752 53.197l13.844-3.137s9.49-31.036 15.716-34.963c6.226-3.928 32.965-13.934 32.965-13.934s10.544 21.314 11.442 30.024c1.179 11.432-2.345 52.132-2.345 52.132l11.725 8.078s14.737-49.866 15.226-55.266c.49-5.4-.49-66.312-.49-66.312h-53.584z"
                fill="#F8B359"
            />
            <path
                d="M154.557 100.002s-23.982 10.303-41.112 8.831c-17.13-1.471-46.818-14.315-46.818-14.315l-.327 9.09s16.508 16.435 34.26 22.084c15.839 5.04 40.564.762 40.564.762s27.137-7.317 13.433-26.452"
                fill="#F7682F"
            />
            <path
                d="M142.129 128.148l-7.337 38.98h53.586l.169-54.258-15.912-9.197-2.863-4.377c-6.18-1.88-25.207 6.159-25.207 6.159l-2.436 22.693z"
                fill="#F7682F"
            />
            <path
                fill="#FFA71A"
                d="M134.793 162.666v4.463l53.828 1.36.383-5.823z"
            />
            <path
                d="M194.574 165.555c5.998-4.641 27.723-19.473 29.643-23.515 2.233-4.7-9.982-14.13-17.944-19.033-5.823-3.584-23.059-19.361-30.259-17.382-7.244 1.993 12.011 29.346 12.011 29.346l15.301 4.881s-9.016 12.361-14.78 20.83l6.028 4.873z"
                fill="#F7682F"
            />
            <path
                d="M188.54 135.135s-3.436-1.9-4.558-3.02c-1.054-1.052-4.137-5.306-4.137-5.306s2.445 11.646 2.75 15.017c.306 3.371 3.12 20.84 3.12 20.84h3.29l-.465-27.53z"
                fill="#DB5A2C"
            />
            <path
                d="M171.949 96.91s16.772-25.8-9.909-32.788c0 0-4.286-.887-5.595 1.172-1.309 2.059-6.133 10.554-6.492 10.846l-1.284 1.044 1.073 1.326s-1.57 4.507-.501 5.638c1.068 1.13 6.472 2.936 7.956 4.143 1.522 1.238.398 4.76-1.33 8.31l16.082.31z"
                fill="#FCC870"
            />
            <path
                d="M156.808 90.822s3.407 1.448 9.077.905c5.829-.558 9.332-2.952 9.332-2.952s-2.314 7.858-2.058 9.973c.257 2.115 0 5.228 0 5.228l-15.366 8.893s-3.734 1.487-4.76-5.838c-1.025-7.325 3.775-16.21 3.775-16.21"
                fill="#F7682F"
            />
            <path
                fill="#FFA71A"
                d="M71.198 94.516l-.805 12.835-4.092-2.692.326-10.14z"
            />
            <path
                d="M188.66 160.677s-3.91 6.708-2.72 8.754c1.19 2.045 13.26 3.58 13.26 3.58s.68-1.535 0-1.705c-.68-.17-8.16-3.238-8.16-3.238l3.534-2.513-5.915-4.878z"
                fill="#FCC870"
            />
            <path
                fill="#FFA71A"
                d="M188.915 157.339l8.734 8.215-2.857 1.29-9.078-6.167z"
            />
            <path
                d="M67.895 260.92l-.294 3.377 35.903-.611s.7-3.853.45-8.23c0 0-4.916-1.317-11.627-3.4l-3.428-.089s-20.115 2.09-21.004 8.954"
                fill="#45494E"
            />
            <path
                fill="#45494E"
                d="M88.973 257.509l2.142-24.476 16.437 4.074-3.219 18.452zM184.955 312.04l-2.205 2.903-27.492-18.503s.333-5.303 3.694-8.611c0 0 3.608 1.37 10.462 4.583l4.804 1.61s14.987 11.901 10.737 18.017"
            />
            <path
                fill="#45494E"
                d="M158.952 287.828l2.332-26.065 19.338 5.723-6.578 27.956zM70.192 185.281l3.359-.233L61.359 8.866 58 9.1z"
            />
            <path
                d="M64.503 94.518s-3.648-.177-3.936 2.286c-.29 2.46 1.968 4.778 1.968 4.778s4.985 1.533 5.563 1.388c.578-.145 1.44-4.403.723-5.937-.719-1.533-4.318-2.515-4.318-2.515"
                fill="#FCC870"
            />
            <path
                d="M142.351 126.074l2.215-7.145-23.447 9.22s12.383 0 21.232-2.075"
                fill="#DB5A2C"
            />
            <path
                fill="#FFA71A"
                d="M152.82 197.68l-3.449-4.311-25.824 13.473-3.003 5.15z"
            />
            <path
                fill="#DB5A2C"
                d="M155.731 165.188h2.154V90.294h-2.154zM164.81 154.94h13.808V143.5H164.81z"
            />
            <path
                fill="#FFA71A"
                d="M128.829 188.173l-8.207-11.133 13.272-9.832 8.207 11.133zM175.626 193.369h13.809v-19.19h-13.81z"
            />
            <path
                d="M178.013 87.807c-.796 1.743 18.695 10.52 14.856 17.91-3.839 7.388.041 14.272-.291 19.603-.332 5.33-5.259 5.893-8.375 4.335-3.116-1.557-3.542-10.019-4.805-12.96-1.264-2.943-7.338-3.76-11.147-8.564-3.807-4.803 5.071-17.58 6.967-19.357l2.795-.967z"
                fill="#DB5A2C"
            />
            <path
                d="M160.268 60.614c-5.249.463-12.416 6.678-9.282 9.434 5.13 4.511 11.235 2.43 10.75 5.339-.483 2.91-2.418 7.517-.483 9.7 1.935 2.182 15.487 1.762 13.794 3.732-1.694 1.97-9.15 15.631-4.849 19.996 4.302 4.365 10.428 4.522 12 7.311 1.572 2.789 2.903 11.155 6.168 12.368 3.266 1.212 8.103.12 7.862-5.214-.242-5.335-4.838-11.761-1.815-19.521 3.024-7.76-17.295-14.385-16.69-16.203.604-1.819 6.508-15.06 3.148-20.053-2.63-3.91-12.687-7.586-20.603-6.889"
                fill="#363A43"
            />
            <path
                d="M175.047 88.819c1.556-.26 4.155.384 4.155.384l-1.142-2.545s-2.27-.626-4.574.302l1.56 1.859z"
                fill="#FFA71A"
            />
            <path
                d="M175.486 75.298c-4.077-1.235-16.71-5.105-18.068-13.372-.36-2.188 6.753-3.525 10.673-3.781 5.607-.367 11.217 3.71 12.545 7.125.658 1.692 1.914 7.226 1.065 11.178 0 0-3.625-.366-6.215-1.15"
                fill="#FB8825"
            />
            <path
                d="M182.02 74.316a26.95 26.95 0 01-.32 2.132s-3.624-.366-6.214-1.15c-4.077-1.235-16.71-5.105-18.068-13.372-.11-.67.478-1.259 1.461-1.762 0 0 .626 2.564 2.73 5.034 5.643 6.624 20.411 9.118 20.411 9.118"
                fill="#FFA71A"
            />
        </g>
    </svg>
);

OrangeFlagIllustrationSvg.displayName = 'OrangeFlagIllustrationSvg';
export default OrangeFlagIllustrationSvg;
